import { AuthService } from "./shared/services/auth/auth.service";

export function authAppInitializerFactory(authService: AuthService): () => Promise<void> {
	return () => authService.runInitialLoginSequence();
}
